import { render } from "./PagoQr.vue?vue&type=template&id=3fef7b48&scoped=true"
import script from "./PagoQr.vue?vue&type=script&lang=js"
export * from "./PagoQr.vue?vue&type=script&lang=js"

import "./PagoQr.vue?vue&type=style&index=0&id=3fef7b48&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fef7b48"]])

export default __exports__